import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { addBankTransfer, getBankDetail, getBankTransfers,getSavedBankAccounts } from 'actions/bankTransferForm'
import BankTransferDisplayForm from 'views/AccountsAndLoans/BankTransferDisplayForm'
// import moment from 'moment'
import { format } from 'date-fns'
import { getEmployeeId } from 'utils/getEmployeeId'
import { commonFunctions } from 'utils/CommonFunctions'
import constants from 'constants'

class BankTransferForm extends Component {
  static propTypes = {
    accountsAndLoans: PropTypes.object.isRequired,
    bankTransferForm: PropTypes.object.isRequired,
    bankSavedAccounts: PropTypes.object.isRequired,
    currentUser: PropTypes.object.isRequired,
    dispatch: PropTypes.func.isRequired,
    forms: PropTypes.object.isRequired,
    hide: PropTypes.func.isRequired,
    id: PropTypes.string,
    modals: PropTypes.object.isRequired,
    selectedPartner: PropTypes.object,
  }

  static defaultProps = {
    id: 'bankTransferForm',
    selectedPartner: null,
  }

  componentDidMount() {
    this.props.dispatch(getBankTransfers(getEmployeeId(this.props.selectedPartner, this.props.currentUser)))
    this.props.dispatch(getSavedBankAccounts(getEmployeeId(this.props.selectedPartner, this.props.currentUser)))
  }

  _submit = (data) => {
    const {
      selectedPartner, currentUser,
    } = this.props

    const formData = {
      employee_id: getEmployeeId(this.props.selectedPartner, this.props.currentUser),
      loginname: '', // loginname is stored on the webapi server session
      fromaccountno: (data.fromAccount ? data.fromAccount : ''),
      fromapvendor: (data.fromAPVendor ? data.fromAPVendor : ''),
      atoeftcoderno: (data.atoEftCodeNo ? data.atoEftCodeNo : ''),
      paygnoticename: (data.paygNoticeName ? data.paygNoticeName : ''),
      toaccountname: (data.toAccountName ? data.toAccountName : ''),
      toaccountno: (data.bankAccountNo ? data.bankAccountNo : ''),
      toaccountbsbno: (data.bankBSB ? data.bankBSB : ''),
      bankname: (data.bankName ? data.bankName : ''),
      bankaddress: (data.bankAddress ? data.bankAddress : ''),
      bankcity: (data.bankCity ? data.bankCity : ''),
      bankstate: (data.bankState ? data.bankState : ''),
      bankcountry: (data.bankCountry ? data.bankCountry : ''),
      bankzip: (data.bankZip ? data.bankZip : ''),
      totalamount: (data.amount ? data.amount : ''),
      // daterequested: `${moment(new Date()).format('YYYY-MM-DD HH:mm:ss')}`, // T00:00:00
      daterequested: `${format(new Date(), constants.DATE_FORMAT.STANDARD_DBSAVE)}`, // T00:00:00
      requestedby: commonFunctions.iff((currentUser.GivenName && currentUser.Surname), `${currentUser.GivenName} ${currentUser.Surname}`, currentUser.DisplayName),
      partnername: (selectedPartner.Name && currentUser.IsAdmin ? selectedPartner.Name : commonFunctions.iff((currentUser.GivenName && currentUser.Surname), `${currentUser.GivenName} ${currentUser.Surname}`, currentUser.DisplayName)),
      transferrequesttype: (data.transferrequesttype ? data.transferrequesttype : ''),
      // emailCc: getEmployeeEmail(this.props.selectedPartner, this.props.currentUser),
    }
    if (data.fromAccount) {
      this.props.dispatch(addBankTransfer(formData, this.props.id))
    }
  }

  _handleBankBSB = (bankBSB) => {
    this.props.dispatch(getBankDetail(bankBSB, getEmployeeId(this.props.selectedPartner, this.props.currentUser)))
  }

  render() {
    console.log("props in containers",this.props)
    const {
      modals, hide, forms, id, accountsAndLoans, bankTransferForm,
    } = this.props
    return (
      <BankTransferDisplayForm
        accountsAndLoans={accountsAndLoans}
        bankTransferForm={bankTransferForm}
        description="To transfer funds select the 'From' account option and the 'To' account option from the drop down lists below and fill in the requested details. Click the 'request transfer' button to verify information and action."
        dispatch={this.props.dispatch}
        forms={forms}
        handleBankBSB={this._handleBankBSB}
        handleSubmit={this._submit}
        hide={hide}
        id={id}
        modals={modals}
        title="Request a Transfer"
      />
    )
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    dispatch,
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  modals: state.modals,
  forms: state.forms,
  accountsAndLoans: state.accountsAndLoans,
  bankTransferForm: state.bankTransferForm,
  selectedPartner: (Object.keys(state.personalinfos.selectedPartner).length === 0 && sessionStorage.getItem('SelectedPartner') !== null ?
    JSON.parse(sessionStorage.getItem('SelectedPartner')) :
    state.personalinfos.selectedPartner),
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BankTransferForm))



// WEBPACK FOOTER //
// ./src/containers/BankTransferForm.js